import React from 'react';
import {
  Breadcrumb, ButtonGroup, ButtonToolbar,
} from 'reactstrap';
import styled from 'styled-components';

import TradeListControlsPlaceholder from './TradeListControlsPlaceholder';

const Controls = styled.div.attrs({
  className: 'ms-auto',
})``;

const Heading = styled.div.attrs({
  className: 'd-flex flex-wrap header mt-4 mb-4',
})``;

/**
 * Loading skeleton component that displays placeholder content for the TradeList header section.
 *
 * Renders animated placeholder elements for the breadcrumb navigation, property title,
 * and control buttons. Rendered as part of the full trade list page skeleton shown behind
 * the route load-failure dialog; that page skeleton hides it from assistive technology.
 * @returns {React.ReactElement} Header placeholder with breadcrumbs, title skeleton, and control
 *   placeholders
 */
function HeaderPlaceholder() {
  return (
    <>
      <Breadcrumb />
      <Heading>
        <div className="mb-2">
          <h1>
            <span className="placeholder placeholder-glow bg-darken" style={{ width: '28.125rem' }} />
          </h1>
          <div>
            <span className="placeholder placeholder-glow bg-darken" style={{ width: '12.5rem' }} />
          </div>
        </div>
        <Controls>
          <ButtonToolbar>
            <ButtonGroup className="ms-2">
              <span className="placeholder placeholder-glow bg-darken" style={{ width: '6.25rem' }} />
            </ButtonGroup>
          </ButtonToolbar>
        </Controls>
      </Heading>
      <TradeListControlsPlaceholder />
    </>
  );
}

export default HeaderPlaceholder;
